/* eslint-disable max-len */
const React = require('react');


const Mobile = ({ alt }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={alt || ''}>
        <path fillRule="evenodd" clipRule="evenodd" d="M4.38159 2.5C4.38205 1.46451 5.22138 0.625556 6.25655 0.625556L13.7533 0.625C14.7888 0.625 15.6283 1.46447 15.6283 2.5V17.5C15.6283 18.5355 14.7888 19.375 13.7532 19.375L6.25659 19.3744C5.22138 19.3744 4.38205 18.5355 4.38159 17.5V2.5ZM14.3783 4.375V15.6267H5.63159L5.63159 4.375H14.3783ZM5.63159 16.8767V17.4997C5.63175 17.8448 5.91152 18.1244 6.25664 18.1244L13.7533 18.125C14.0984 18.125 14.3783 17.8452 14.3783 17.5V16.8767H5.63159ZM14.3783 3.125H5.63159V2.50016C5.63181 2.15515 5.91156 1.87556 6.25659 1.87556L13.7533 1.875C14.0984 1.875 14.3783 2.15482 14.3783 2.5V3.125Z" fill="#009EE3" />
    </svg>
);

module.exports = Mobile;
